import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, createElementVNode as _createElementVNode, createVNode as _createVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "serp__filter-subitem q-list-group q-list-group-flush"
}
const _hoisted_2 = ["value", "onChange", "checked"]


import FilterBadge from "@/components/SerpPage/FiltersContainer/FiltersList/FilterItem/FilterLabel.vue";

import {useFiltersStore} from "@/store/SerpPage/FiltersStore";


export default /*@__PURE__*/_defineComponent({
  __name: 'SubCategoryItem',
  props: ['filter', 'field'],
  setup(__props) {


const filtersStore = useFiltersStore();


return (_ctx: any,_cache: any) => {
  const _component_SubCategoryItem = _resolveComponent("SubCategoryItem", true)!

  return (__props.filter.aggregations.length > 0 && __props.filter.label !== '')
    ? (_openBlock(), _createElementBlock("ul", _hoisted_1, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.filter.aggregations, (aggregate) => {
          return (_openBlock(), _createElementBlock("li", {
            class: "serp__filter-subitem--element q-list-group-item",
            key: aggregate.label
          }, [
            _createElementVNode("input", {
              class: "serp__filter-subitem--input q-form-check-input q-me-2",
              type: "checkbox",
              value: __props.field,
              onChange: ($event: any) => (_unref(filtersStore).updateCategoryItem(__props.field, aggregate.label)),
              checked: _unref(filtersStore).filterIsChecked(__props.field, aggregate.label)
            }, null, 40, _hoisted_2),
            _createVNode(FilterBadge, { filter: aggregate }, null, 8, ["filter"]),
            (aggregate.aggregations.length > 0 )
              ? (_openBlock(), _createBlock(_component_SubCategoryItem, {
                  key: 0,
                  filter: aggregate,
                  field: __props.field
                }, null, 8, ["filter", "field"]))
              : _createCommentVNode("", true)
          ]))
        }), 128))
      ]))
    : _createCommentVNode("", true)
}
}

})